import { ChevronRight, Download, FileSpreadsheet, FileText, Folder, Trash2 } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

export const ROW = "group grid grid-cols-[minmax(0,1fr)_auto] sm:[grid-template-columns:var(--cols)] items-center gap-3 px-3 py-1.5 rounded-md transition-colors duration-100";

const etatCoche = (ids, sel) => {
  const n = ids.filter((i) => sel.has(i)).length;
  if (!n) return false;
  return n === ids.length ? true : "indeterminate";
};

export const tailleFr = (o) => {
  if (o == null) return "—";
  if (o < 1024) return `${o} o`;
  if (o < 1024 * 1024) return `${Math.round(o / 1024)} Ko`;
  return `${(o / 1024 / 1024).toFixed(1)} Mo`;
};

const dateFr = (iso) => (iso ? new Date(iso).toLocaleString("fr-CA", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const FolderRow = ({ nom, ids, depth, ouvert, onToggle, sel, onCoche, testId }) => (
  <div className={`${ROW} cursor-pointer select-none hover:bg-sky-50`} onClick={onToggle} data-testid={testId}>
    <div className={`flex items-center gap-2 min-w-0 ${depth ? "pl-3 sm:pl-6" : ""}`}>
      <span onClick={(e) => e.stopPropagation()} className="flex">
        <Checkbox checked={etatCoche(ids, sel)} disabled={!ids.length} onCheckedChange={(v) => onCoche(ids, v === true)} data-testid={`${testId}-check`} />
      </span>
      <ChevronRight className={`h-4 w-4 shrink-0 text-slate-400 transition-transform duration-150 ${ouvert ? "rotate-90" : ""}`} />
      <Folder className="h-5 w-5 shrink-0 fill-sky-400 text-sky-500" />
      <span className="truncate text-sm text-slate-800">{nom}</span>
      <span className="text-[11px] font-mono text-slate-400" data-testid={`${testId}-count`}>{ids.length}</span>
    </div>
    <span className="hidden sm:block" /><span className="hidden sm:block" /><span className="hidden sm:block" /><span />
  </div>
);

const Action = ({ onClick, disabled, title, danger, children, testId }) => (
  <button type="button" onClick={onClick} disabled={disabled} title={title} data-testid={testId}
    className={`grid h-7 w-7 place-items-center rounded-md text-slate-400 transition-colors disabled:opacity-30 disabled:cursor-not-allowed ${danger ? "hover:bg-red-50 hover:text-red-600" : "hover:bg-slate-100 hover:text-slate-800"}`}>
    {children}
  </button>
);

export const FileRow = ({ f, sel, onCoche, onDownload, onDelete, onOpen }) => {
  const Icone = f.nom.toLowerCase().endsWith(".pdf") ? FileText : FileSpreadsheet;
  return (
    <div className={`${ROW} hover:bg-slate-100/80 ${sel.has(f.id) ? "bg-sky-100/70" : ""}`} data-testid={`fichier-${f.id}`}>
      <div className="flex items-center gap-2 min-w-0 pl-6 sm:pl-12">
        <Checkbox checked={sel.has(f.id)} onCheckedChange={(v) => onCoche([f.id], v === true)} data-testid={`fichier-check-${f.id}`} />
        <Icone className="h-4 w-4 shrink-0 text-slate-500" />
        <button type="button" onClick={() => onOpen(f)} className="min-w-0 truncate text-left text-sm text-slate-700 underline-offset-2 hover:text-sky-700 hover:underline" title={`Voir le contenu de ${f.nom}`} data-testid={`fichier-nom-${f.id}`}>{f.nom}</button>
        {f.type === "facture_booking" && <span className="shrink-0 rounded bg-blue-50 px-1.5 text-[10px] font-medium text-[#003580]">Facture</span>}
        {f.logement && <span className="hidden md:inline min-w-0 shrink-[100] truncate text-[11px] text-slate-400">· {f.logement}</span>}
      </div>
      <span className="hidden sm:block truncate text-xs text-slate-500" data-finder-col="date">{dateFr(f.importe_le)}</span>
      <span className="hidden sm:block truncate text-right text-xs text-slate-500" data-finder-col="contenu">
        {f.type === "preuve_booking" ? "Preuve" : f.type === "rapprochement" ? `${f.lignes} dépôt${f.lignes > 1 ? "s" : ""}` : `${f.lignes} ligne${f.lignes > 1 ? "s" : ""}`}{f.doublons ? <span className="text-slate-400"> · {f.doublons} doubl.</span> : null}
      </span>
      <span className="hidden sm:block truncate text-right text-xs font-mono text-slate-500" data-finder-col="taille">{f.taille == null
        ? <span className="italic text-slate-400" title="Taille inconnue : fichier importé avant la conservation des originaux. Réimportez-le pour l'obtenir." data-testid={`fichier-taille-inconnue-${f.id}`}>inconnue</span>
        : tailleFr(f.taille)}</span>
      <div className="flex justify-end gap-0.5">
        <Action onClick={() => onDownload(f)} disabled={!f.telechargeable} testId={`fichier-telecharger-${f.id}`}
          title={f.telechargeable ? "Télécharger le fichier d'origine" : "Fichier d'origine non conservé (importé avant cette fonction)"}>
          <Download className="h-4 w-4" />
        </Action>
        <Action onClick={() => onDelete([f.id])} danger title="Supprimer" testId={`fichier-supprimer-${f.id}`}><Trash2 className="h-4 w-4" /></Action>
      </div>
    </div>
  );
};
